import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable()
export class AppUrl {

    static get API_URL(): string {
        return environment.appUrl + 'api/';

    }
    static CONTACT_US(id?): string {
        if (id) {
            return AppUrl.API_URL + 'contact-us/' + id;
        } else {
            return AppUrl.API_URL + 'contact-us';
        }
    }
    static BLOG_DEATILS(id): string {
        return AppUrl.API_URL + 'blogs/' + id;
    }


    static BLOGBYTITLE(title: any): string {
        return AppUrl.API_URL + 'blogsbytitle/' + title;
    }



    static NEWS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'news/' + id;
        } else {
            return AppUrl.API_URL + 'news';
        }
    }

    static ENQUIRY(id?): string {
        if (id) {
            return AppUrl.API_URL + 'enquiry/' + id;
        } else {
            return AppUrl.API_URL + 'enquiry';
        }
    }
}
